import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import ModularTooltip from '../../../../../_components/common/ModularTooltip';
import EmployeeDepartmentTable from '../../../../../_components/common/EmployeeDepartmentTable';
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { attritionPredictorAction } from '../../../../../_actions/Analyze/attritionPredictor.action'
import {global_data } from '../../globalData'
import dataFormater from '../../dataFormater'

class AttritionPredictor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            navData: [],
            Tooltip: false,
            selected_route_parameter: null,
            attritionData: [],
            filterData: null,
            subData: [
                {
                    name: 'Goal or Target-setting suffers'
                }, {
                    name: 'Strategy Planning is low'
                }, {
                    name: 'Project planning and execution becomes challenging'
                }, {
                    name: 'One-to-one meetings'
                }
            ]
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '' ) {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Attrition Predictor') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

         //filter data
         if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse})
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        if(this.props.attrPredDataResonse !== '') {
            this.setState({attritionData: dataFormater(this.props,this.props.attrPredDataResonse.data,'attr_pre')})
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.attrPredDataResonse !== this.props.attrPredDataResonse) {
            if(this.props.attrPredDataResonse !== '') {
                this.setState({attritionData: dataFormater(this.props,this.props.attrPredDataResonse.data,'attr_pre')})
            }
        }

        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }


    onClickEmployee = (key) => {
        this.setState({ selected_route_parameter: key, Tooltip: !this.state.Tooltip })
    }

    callback() {
        this.setState({ Tooltip: false })
    }

    renderCustomComponent = (val, subData) => {
        return (
            <div>
                <div className="d-flex flex-row flex-wrap mb-2">
                    {
                        this.state.subData.map(
                            (data, i) => {
                                return <React.Fragment key={i}>
                                    <div className="">
                                        <small className="font-weight-bold font-italic" style={{fontSize: 10}}>- {data.name}</small>
                                    </div>

                                </React.Fragment>
                            }
                        )
                    }
                </div>
            </div>
        )
    }

    render() {
        const { navData, attritionData } = this.state
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                            this.props.singleValidatorResponse ?
                            <p className="text-center">
                                    Team Members should be more than 2
                            </p>:
                            <div className="swot-container-sub">
                                <p className=" text-center font-weight-bold mt-5">Those at probable Risk of Attrition (Higher to Lower)</p>
                                <EmployeeDepartmentTable
                                    headings={[
                                        {
                                            headingName: 'Employee',
                                            headingColor: 'bg-danger'
                                        },
                                        {
                                            headingName: 'Retention tips',
                                            headingColor: 'bg-success'
                                        }
                                    ]}
                                    attritionData={this.state.attritionData}
                                    Tooltip={this.state.Tooltip}
                                    selected_route_parameter={this.state.selected_route_parameter}
                                    onClickEmployee={(key) => this.onClickEmployee(key)}
                                />
                                {
                                    this.state.Tooltip ?
                                        <ModularTooltip
                                            modalHeader={false}
                                            toggleValue={this.state.Tooltip}
                                            id={`AttritionTarget${`${this.state.selected_route_parameter}`}`}
                                            customComponent={this.renderCustomComponent(this.state.subData)} 
                                            callbackPopover={this.callback.bind(this)}
                                            placement="bottom-end"
                                            title="" /> :
                                        null
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Analyze
    const { getAttrPreLoading } = state.attritionPredictorReducer
    const { getAttrPreError} = state.getAnalyzeData
    const attrPredDataResonse = (!getAttrPreLoading && !getAttrPreError) ?  state.attritionPredictorReducer.data: '';

         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;

    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

    const singleValidatorResponse = state.singleValidatorReducer.data;



    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        attrPredDataResonse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(AttritionPredictor)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/AttritionPredictor/index.js